import { render, staticRenderFns } from "./CreateClientComponent.vue?vue&type=template&id=4c3f42b0&"
import script from "./CreateClientComponent.vue?vue&type=script&lang=js&"
export * from "./CreateClientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports